import React from 'react';
import styled from 'styled-components';
import { Loading } from 'tdesign-react';
import { connect } from 'react-redux';
import dayjs from 'dayjs';
import { isEmpty } from 'lodash';
import NoData from '@/components/NoData';
import { convertByte } from '@/utils/common';
import ClusterSwitch from '@/components/Cluster/ClusterSwitch';
import ListItem from './ListItem';

function ListContainer({ loading, list }) {
  return (
    <Root>
      <ClusterSwitch />
      <Loading loading={loading} />
      {isEmpty(list) ? (
        <NoData style={{ marginTop: 160 }} />
      ) : (
        list.map((item, index) => (
          <ListItem
            {...item}
            key={index}
            title={item.clusterName}
            displayName={item.displayName}
            node={item.clusterEnv}
            alive={item.clusterStatus === 'live'}
            chartPercent={Number(item.clusterHealth)}
            createTime={dayjs(item.createTime).format('YYYY-MM-DD hh:mm:ss')}
            tags={getTags(item)}
            version={item.clusterVersion}
            items={getItems(item)}
          />
        ))
      )}
    </Root>
  );
}

export default connect((state) => ({
  loading: state.kopCluster.loading,
  list: state.kopCluster.list,
}))(ListContainer);

const getTags = (item) => {
  const tags = [];
  if (item.deployEnv) {
    tags.push({
      title: item.deployEnv,
      background: 'rgba(102, 136, 255, 0.12)',
      color: '#6688FF',
    });
  }
  if (item.deployVersion) {
    tags.push({
      title: item.deployVersion,
      background: 'rgba(16, 184, 128, 0.10)',
      color: '#10B880',
    });
  }
  if (item.clusterUsage) {
    tags.push({
      title: item.clusterUsage,
      background: 'rgba(244, 157, 11, 0.10)',
      color: '#F49D0B',
    });
  }
  return tags;
};

const getItems = (item) => {
  let propertyArray = [];
  if (item.clusterType === 'kop') {
    propertyArray = [
      {
        title: 'Bookies',
        value: `${item.activeBookiesCount}/${item.bookiesCount}`,
      },
      {
        title: 'ZK',
        value: `${item.activeZkCount}/${item.zkCount}`,
      },
    ];
  }

  if (item.clusterType === 'kafka') {
    propertyArray = [
      {
        title: 'ConsumerGroup',
        value: item.consumerGroupCount,
      },
    ];
  }
  return [
    {
      title: 'Brokers',
      value: `${item.activeBrokersCount}/${item.brokersCount}`,
    },
    ...propertyArray,
    {
      title: '消息总大小',
      ...convertByte(item.messageSize),
    },
    {
      title: 'Topic总数',
      value: item.topicCount,
    },
  ];
};

const Root = styled.div`
  flex: 1;
  min-width: 750px;
  position: relative;
  .t-loading {
    position: absolute;
    top: 200px;
    left: 0;
    right: 0;
    margin: auto;
    z-index: 10;
  }
`;
